import { combineReducers } from 'redux';

import tots from './tots';
import idsFiltratsPelMapa from './idsFiltratsPelMapa';
import idAvisSeleccionat from './idAvisSeleccionat';
import peticioObtenirEnCurs from './peticioObtenirEnCurs';
import peticioEliminarEnCurs from './peticioEliminarEnCurs';

export default combineReducers({
    tots,
    idsFiltratsPelMapa,
    idAvisSeleccionat,
    peticioObtenirEnCurs,
    peticioEliminarEnCurs
});



// WEBPACK FOOTER //
// ./src/reducers/avis/visualitzacio/avisos/index.js